import Vue from 'vue'

const Rollbar = require('vue-rollbar')
Vue.use(Rollbar, {
  accessToken: 'f82fc5fcaf544b36aa295d2ae30cb79a',
  captureUncaught: true,
  captureUnhandledRejections: true,
  enabled: process.env.NODE_ENV === 'production',
  source_map_enabled: true,
  environment: process.env.NODE_ENV,
  payload: {
    client: {
      javascript: {
        code_version: '1.4.3',
      },
    },
  },
})

/* eslint-disable no-console */
Vue.config.errorHandler = function (error) {
  if (process.env.NODE_ENV === 'development') {
    console.error(error)
    return
  }

  Vue.rollbar.error(error)
  if (!error._handled) {
    console.error(error)
  }
}

Vue.mixin({
  data: () => ({
    asyncPending: 0,
  }),

  beforeCreate() {
    const methods = this.$options.methods
    for (const key of Object.keys(methods || {})) {
      const method = methods[key]
      if (method._busyTracked) return
      const wrappedMethod = function (...args) {
        const result = method.apply(this, args)
        const isPromise = result && typeof result.then === 'function'
        if (!isPromise) return result

        return new Promise(async (resolve, reject) => {
          this.asyncPending++
          try {
            resolve(await result)
          } catch (error) {
            if (!error._handled) {
              error._handled = true
              Vue.config.errorHandler(error)
            }
            reject(error)
          }
          this.asyncPending--
        })
      }
      this.$options.methods[key] = wrappedMethod
      wrappedMethod._busyTracked = true
    }
  },
})
